import _ from "lodash";

let FilterList = (result, item) => {
	var index = _.findIndex(result, (result) => {
		return result.refundFromTable;
	});

	var x = _.transform(
		result,
		(acc, v) => {
			if (index >= 0) {
				acc.push({
					id: v.id,
					tool_id: v.tool_id.split(" , "),
					date_from: v.date_from.split(" , "),
					date_to: v.date_to.split(" , "),
					units: v.units.split(" , "),
					status: v.status.split(" , "),
					refundFromTable: v.refundFromTable,
					refundIdFromTable: v.refundIdFromTable
				});
			} else {
				acc.push({
					id: v.id,
					tool_id: v.tool_id.split(" , "),
					date_from: v.date_from.split(" , "),
					date_to: v.date_to.split(" , "),
					units: v.units.split(" , "),
					status: v.status.split(" , "),
					table_type: v.table_type
				});
			}
		},
		[]
	);

	var y = _.transform(
		x,
		(result, val) => {
			if (index >= 0) {
				for (let i = 0; i < val.tool_id.length; i++) {
					result.push({
						id: _.parseInt(val.id),
						tool_id: _.parseInt(val.tool_id[i]),
						date_from: val.date_from[i],
						date_to: val.date_to[i],
						units: _.parseInt(val.units[i]),
						status: _.parseInt(val.status[i]),
						refundFromTable: _.parseInt(val.refundFromTable),
						refundIdFromTable: _.parseInt(val.refundIdFromTable)
					});
				}
			} else {
				for (let i = 0; i < val.tool_id.length; i++) {
					result.push({
						id: _.parseInt(val.id),
						tool_id: _.parseInt(val.tool_id[i]),
						date_from: val.date_from[i],
						date_to: val.date_to[i],
						units: _.parseInt(val.units[i]),
						status: _.parseInt(val.status[i]),
						table_type: val.table_type
					});
				}
				//console.log(val.status);
			}
		},
		[]
	);

	var f = _.filter(y, (val) => {
		var items = item;
		//console.log(val);
		//console.log(item);
		if (val.status >= 1 && val.tool_id === _.parseInt(items.id)) {
			//console.log(val);
			return val;
		}
	});

	return f;
};

export default FilterList;
